/* eslint-disable max-lines */
import React from 'react';
import {
    Link, useLocation, useParams
} from 'react-router-dom';
import {
    cn
} from 'shared/lib/utils';

/**
 * DEStudioSubStrip — internal section tabs for DE Studio.
 *
 * Renders only on DE Studio's inner pages (not the gate). Carries the four
 * sections: Workforce · Library · Activity · Knowledge. Brand + product
 * tabs + platform peers all live in DSPlatformBar above this strip.
 */
const SUB_PAGES = [
    {
        key: 'unified-builder',
        label: 'Workforce'
    },
    {
        key: 'library',
        label: 'Library'
    },
    {
        key: 'activity',
        label: 'Activity'
    },
    {
        key: 'usage',
        label: 'Usage'
    }
    // Knowledge tab removed — collections live under Library → Collections
    // and open their editor inline via de-studio/knowledge/:colId/:fileName.
];

export default function DEStudioSubStrip() {
    const {
        pathname
    } = useLocation();
    const {
        oragID, subOragID
    } = useParams();
    const base = `/organizations/${oragID}/sub/${subOragID}/de-studio`;

    const active = SUB_PAGES.find((p) => pathname.includes(`/de-studio/${p.key}`))?.key
        || (pathname.includes('/de-studio/knowledge') || pathname.includes('/de-studio/channels') ? 'library' : 'unified-builder');

    return (
        <div
            style={{
                position: 'sticky',
                top: 56,
                zIndex: 19,
                background: 'var(--ds-bg)',
                borderBottom: '1px solid var(--ds-divider)',
                display: 'flex',
                alignItems: 'center',
                padding: '0 20px',
                height: 44
            }}
        >
            <nav style={{
                display: 'flex',
                gap: 4
            }}>
                {SUB_PAGES.map((p) => {
                    const isActive = active === p.key;
                    return (
                        <Link
                            key={p.key}
                            to={`${base}/${p.key}`}
                            className={cn('ds-tab', isActive && 'ds-tab-active')}
                        >
                            {p.label}
                        </Link>
                    );
                })}
            </nav>
        </div>
    );
}
